const Overview = () => {
    return (
        <div id="overview" className="vision-card">
                <h3>OVERVIEW</h3>

                <p>
                    In Kasia, during the year 1990, Mrs. H.P. Sam realised the need of an english medium 
                    school in Kushinagar distt. These great people, our Founders, established a school 
                    at Sapaha Road Kasia. In 1997, the school was shifted to the present Anand Nagar 
                    from where the seed planted in 1990 really began to take root, blossom and flourish 
                    while it grew into the institution the school is today. In 1996 the Society was 
                    formed, the object of which was to govern a school that would provide a holistic 
                    education to students, based on Protestant Christian principles. The school is 
                    managed by The Nav Jeevan Mission Society, a society registered under the Societies 
                    Act of 1860 and under the guidance of the Society the school has continued to 
                    flourish and progress and has firmly established itself as an educational institution 
                    that ranks among the finest in the country and which continues to develop and 
                    improve – true to the school motto –Arise & Shine. The academic year during which the 
                    students are in residence and attend classes, extends normally from April to March.
                </p>
            </div>
    );
};

export default Overview;